"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEngagementMetric = void 0;
const OmnitureHelper_1 = require("../OmnitureHelper");
const sendEngagementMetric = (pageName, action, subPage) => {
    const model = new OmnitureHelper_1.AdobeOmnitureBuilder(pageName)
        .withSubPageName(subPage !== null && subPage !== void 0 ? subPage : OmnitureHelper_1.AdobeOmnitureBuilder.DEFAULT_VALUE)
        .withPageAction(action)
        .build();
    try {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(model);
    }
    catch (err) {
        console.error(`Error sending Adobe Omniture metrics. Page: ${pageName}, Action: ${action}`);
    }
};
exports.sendEngagementMetric = sendEngagementMetric;
